// @flow
import React from 'react'
import classnames from 'classnames'
import { Editor, EditorState, convertFromRaw, ContentState } from 'draft-js'
import styles from './editor.module.scss'

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  lyrics: any
  placeholder?: string
  readOnly?: boolean
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange?: (e: any) => void
}

interface State {
  editorState: EditorState
  isFocus: boolean
}

class LyricsEditor extends React.Component<Props, State> {
  // eslint-disable-next-line react/static-property-placement
  public static defaultProps: Partial<Props> = {
    placeholder: 'Please input lyrics',
    readOnly: false,
    onChange: (f) => f,
  }

  editor = null

  constructor(props) {
    super(props)
    const { lyrics } = props
    let editorState
    if (!lyrics) {
      editorState = EditorState.createEmpty()
    }
    else if (typeof lyrics !== 'string') {
      editorState = EditorState.createWithContent(convertFromRaw(lyrics))
    }
    else {
      editorState = EditorState.createWithContent(
        ContentState.createFromText(lyrics),
      )
    }

    this.state = {
      editorState,
      isFocus: false,
    }
  }

  // componentDidMount() {
  //
  // }

  onChange = (editorState) => {
    const { onChange } = this.props
    const contentState = editorState.getCurrentContent()
    const plainText = contentState.getPlainText()

    this.setState({ editorState })
    onChange(plainText)
  }

  onClick = () => this.editor.focus()

  onFocus = () => this.setState({ isFocus: true })

  onBlur = () => this.setState({ isFocus: false })

  render() {
    const { placeholder, readOnly } = this.props
    const { editorState, isFocus } = this.state
    return (
      // eslint-disable-next-line max-len
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
      <div
        className={classnames(styles.editor, {
          [styles.focus]: isFocus,
          [styles.readOnly]: readOnly,
        })}
        onClick={this.onClick}
      >
        <Editor
          ref={(element) => {
            this.editor = element
          }}
          editorState={editorState}
          onChange={this.onChange}
          placeholder={placeholder}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          readOnly={readOnly}
          stripPastedStyles
        />
      </div>
    )
  }
}

export default LyricsEditor
